export class Involved {
  constructor(
    public id: number,
    public ticketId: number,
    public involved: string
  ) {}

  public static get EMPTY(): Involved {
    return new Involved(0, 0, "");
  }
}
